import { Injectable } from '@angular/core';
import {
  IProviderDropdown,
  IUserList,
} from '@g99-product-web-ui/shared-interface-lib';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { HttpService } from '../../core/http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalUserService {
  constructor(private readonly _httpService: HttpService) {}

  public getAllUsers(): Observable<IUserList[]> {
    return this._httpService.get<IUserList[]>(
      API_ENDPOINTS.USER_ENDPOINTS.v1UserList
    );
  }

  public getAllUsersForInbox(): Observable<IUserList[]> {
    return this._httpService.get<IUserList[]>(
      API_ENDPOINTS.USER_ENDPOINTS.v1InboxUserList
    );
  }

  public getProviderByServiceId(
    ids: number[]
  ): Observable<IProviderDropdown[]> {
    return this._httpService.get<IProviderDropdown[]>(
      API_ENDPOINTS.USER_ENDPOINTS.providerListByServiceId(ids)
    );
  }
}
